module.exports = "<app-success-header #succHeader>\r\n</app-success-header>\r\n\r\n<div class=\"success-desc\">\r\n  <p class=\"success-text\"\r\n    [innerHtml]=\"pageContent?.fourthTabSection3Title\">\r\n  </p>\r\n  <div\r\n    [innerHtml]=\"pageContent?.fourthTabSection3Text\">\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/buyback-form/main-section/tabs/last-tab/last-tab.component.html
// module id = ./src/app/buyback-form/main-section/tabs/last-tab/last-tab.component.html
// module chunks = main